module.exports = __webpack_public_path__ + "img/A913.cc8c6f02.jpg";